export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const SITE_URL = import.meta.env.VITE_SITE_URL;

// auth
export const LOGIN = "/auth/login" as const;
export const REFRESH = "/auth/refresh" as const;

// transactions
export const GET_TRANSACTIONS = "/transactions/" as const;
export const GET_TRANSACTIONS_STATS = "/transactions/stats" as const;
export const GET_IS_AUTH = "/auth/is-auth" as const;

// users
export const GET_USERS = "/users/" as const;
export const GET_USERNAMES =  "/users/get-usernames" as const;
export const POST_USER_ACCESS = "/users/user-access" as const;
export const CHANGE_USER_STATUS = "/users/change-user-status" as const;
export const CHANGE_ATTACHED_BUSINESS = "/users/change-attached-business" as const;
export const CHANGE_ACCOUNT_TYPE = "/users/change-account-type" as const;

// support
export const ADD_SUPPORT_TICKET = "/support/add-support-ticket" as const;
export const GET_SUPPORT_TICKETS = "/support/get-support-tickets" as const;
export const CHANGE_STATUS_SUPPORT_TICKETS = "/support/change-status-support-ticket" as const;
export const UPDATE_NOTES_TICKETS = "/support/update-notes" as const;

// business
export const GET_BUSINESS_USERNAMES =  "/business/get-usernames" as const;

// marketing
export const SEND_EMAIL =  "/marketing/send-email" as const;
export const EXCEL_REPORT =  "/marketing/excel-report" as const;
export const IMAGE_FOR_NEWSLETTERS_UPLOAD =  "/marketing/image-for-newsletters-upload" as const;
export const CLEAR_UPLOAD_NEWSLETTERS_FOLDER =  "/marketing/clear-upload-newsletters" as const;

// settings
export const GET_SETTING = "/settings/get-setting" as const;
export const SAVE_SETTING = "/settings/save-setting" as const;

// partners
export const GET_PARTNERS = "/partners/" as const;
export const GET_PARTNERS_USERNAMES = "/partners/get-usernames" as const;
export const CHANGE_PARTNER_STATUS = "/partners/change-partner-status" as const;
